/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import HexGroup from 'solis/type/hex/group';
import HexFrontier from 'solis/type/hex/frontier';


export default class BoardEdgeDistance extends Logic
{
  constructor (board)
  {
    super(board);

    this.distances = new Map();

    const isZone = (hex) =>
    {
      return board.getZone(hex) !== null;
    };

    for (const frontier = new HexFrontier(this.#getEdgeGroup(), isZone); !frontier.empty(); frontier.expand())
    {
      for (const hex of frontier)
      {
        this.distances.set(hex.toString(), frontier.getDistance());
      }
    }
  }


  #getEdgeGroup ()
  {
    return new HexGroup(this.object.getZones().keys()).getNeighbors();
  }


  getDistance (hex)
  {
    return this.distances.get(hex.toString());
  }


};
